import _ from 'lodash';
import React, { Children, useEffect } from 'react';
import { Center, Circle, Queue, Stack, Box } from '..';
import { Overlay, Padding } from '../layout';
import { LeftArrow, RightArrow } from '../sign';
import { CarouselImage } from './image';
import {
  CarouselChild,
  CarouselContentWrapper,
  CarouselWrapper,
  useCarouselSlider,
} from './shared-components';

export const Carousel = (props) => {
  let { children, images, duration, buttoned } = props;
  const slides = React.Children.toArray(children);
  const length = slides.length;

  // Todo: the first param of useCarouselSlider (length) is hacked to restart right now. Ideally
  // it should be dynamic to the number of people in the carousel. It works well if there are 6 people,
  // but not for 5. If we increase the size of the carousel in the future, this param needs to be modified.
  let {
    handlePrevious,
    handleNext,
    activePageIndicator,
    setActivePageIndicator,
  } = useCarouselSlider(3, duration);

  return (
    <div>
      <Stack size={6}>
        {!_.isEmpty(images) && (
          <CarouselImage
            images={images}
            handlePrevious={handlePrevious}
            handleNext={handleNext}
            index={activePageIndicator}
            length={length}
          />
        )}

        <CarouselWrapper>
          <CarouselContentWrapper
            count={3}
            index={activePageIndicator}
            length={length}
          >
            {slides.map((slide, index) => {
              return <CarouselChild key={index}>{slide}</CarouselChild>;
            })}
          </CarouselContentWrapper>
          {buttoned && (
            <>
              <Overlay height="100%" left={0} top={-20}>
                <Center>
                  <LeftArrow onClick={handlePrevious} />
                </Center>
              </Overlay>
              <Overlay height="100%" right={0} top={-20}>
                <Center>
                  <RightArrow onClick={handleNext} />
                </Center>
              </Overlay>
            </>
          )}
        </CarouselWrapper>

        {!buttoned && (
          <Center>
            <Queue size={4}>
              {Children.map(children, (child, index) => {
                return (
                  <Circle
                    size={3}
                    color={activePageIndicator === index ? 'black' : 'grey'}
                    key={index}
                    onClick={() => {
                      setActivePageIndicator(index);
                    }}
                  />
                );
              })}
            </Queue>
          </Center>
        )}
      </Stack>
    </div>
  );
};

export const CarouselMobile = (props) => {
  let { children, images, duration, buttoned } = props;
  const slides = React.Children.toArray(children);
  const length = slides.length;
  let {
    handlePrevious,
    handleNext,
    activePageIndicator,
    setActivePageIndicator,
  } = useCarouselSlider(length, duration);

  return (
    <div>
      <Stack size={6}>
        {!_.isEmpty(images) && (
          <CarouselImage
            images={images}
            handlePrevious={handlePrevious}
            handleNext={handleNext}
            index={activePageIndicator}
            length={length}
          />
        )}

        <CarouselWrapper>
          <CarouselContentWrapper index={activePageIndicator} length={length}>
            {slides.map((slide, index) => {
              return <CarouselChild key={index}>{slide}</CarouselChild>;
            })}
          </CarouselContentWrapper>
          {buttoned && (
            <>
              <Overlay height="100%" left={0} top={-20}>
                <Center>
                  <LeftArrow onClick={handlePrevious} />
                </Center>
              </Overlay>
              <Overlay height="100%" right={0} top={-20}>
                <Center>
                  <RightArrow onClick={handleNext} />
                </Center>
              </Overlay>
            </>
          )}
        </CarouselWrapper>

        <Center>
          <Queue size={4}>
            {Children.map(children, (child, index) => {
              return (
                <Circle
                  size={3}
                  color={activePageIndicator === index ? 'black' : 'grey'}
                  key={index}
                  onClick={() => {
                    setActivePageIndicator(index);
                  }}
                />
              );
            })}
          </Queue>
        </Center>
      </Stack>
    </div>
  );
};

export const CarouselDesktop = (props) => {
  let { children, images, duration } = props;
  const slides = React.Children.toArray(children);
  const length = slides.length;
  let { handlePrevious, handleNext, activePageIndicator } = useCarouselSlider(
    length,
    duration
  );
  return (
    <Stack size={6}>
      <CarouselWrapper>
        <CarouselContentWrapper index={activePageIndicator} length={length}>
          {slides.map((slide, index) => {
            return (
              <Padding size={[0, 8, 0, 7]} width="100%" key={index}>
                <Queue width="100%" size={4}>
                  <CarouselChild key={index}>{slide}</CarouselChild>
                  <Box ratio={0.4} backgroundImage={images[index]} />
                </Queue>
              </Padding>
            );
          })}
        </CarouselContentWrapper>

        <Overlay height="100%" left={4} top={0}>
          <Center>
            <LeftArrow onClick={handlePrevious} />
          </Center>
        </Overlay>
        <Overlay height="100%" right={4} top={0}>
          <Center>
            <RightArrow onClick={handleNext} />
          </Center>
        </Overlay>
      </CarouselWrapper>
    </Stack>
  );
};

export const CarouselTablet = (props) => {
  let { children, images, duration } = props;
  const slides = React.Children.toArray(children);
  const length = slides.length;

  let { handlePrevious, handleNext, activePageIndicator } = useCarouselSlider(
    length,
    duration
  );
  return (
    <Stack size={6}>
      <CarouselWrapper>
        <CarouselContentWrapper index={activePageIndicator} length={length}>
          {slides.map((slide, index) => {
            return (
              <Padding size={[0, 0, 0, 7]} width="100%">
                <Queue width="100%" size={4}>
                  <CarouselChild key={index}>{slide}</CarouselChild>
                  <Box ratio={0.4} backgroundImage={images[index]} />
                </Queue>
              </Padding>
            );
          })}
        </CarouselContentWrapper>
        <Overlay height="100%" left={4} top={0}>
          <Center>
            <LeftArrow onClick={handlePrevious} />
          </Center>
        </Overlay>
        <Overlay height="100%" right={4} top={0}>
          <Center>
            <RightArrow onClick={handleNext} />
          </Center>
        </Overlay>
      </CarouselWrapper>
    </Stack>
  );
};
